import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import CustomLegends from "./CustomLegends";
import { getCommonOptions } from "./cardConfig";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { isDatasetsDataEmpty, isValidChartData } from "../../Data/options";
import NoSubscription from "../NoSubscription";
import { OverlayTrigger, Tooltip as ReactBootstrapTooltip } from "react-bootstrap";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChartCard = ({
  data,
  chartTitle,
  formatType,
  metric,
  isDummyData,
  noSubscription,
  layoutItem,
  showTimePeriod,
  DateRange,
  periodValue
}) => {
  const aspectRatio=layoutItem ? layoutItem?.w/layoutItem.cols : 1;
  const renderBarChart = () => {
    if (!data || !isValidChartData(data)) {
      return <>Something went wrong.</>;
    }

    

    const datasets = data.datasets?.map((x: any) => x);
    const commonOptions = getCommonOptions(formatType, metric, isDummyData);

    const barOptions: any = {
      ...commonOptions,
      categoryPercentage: 1,
      barPercentage: 0.75,
      plugins:{
        ...commonOptions.plugins,
        tooltip:{
          ...commonOptions.plugins.tooltip,
          mode:"x",
          titleFont: { 
            family: "OpenSans", 
          },
          bodyFont: { 
            family: "OpenSans", 
          },
          footerFont: { 
            family: "OpenSans", 
          },
        }
      },
      scales: {
        x:{
          ...commonOptions.scales.x,
          ticks:{
            display: noSubscription ? false: true,
           ...commonOptions.scales.x.ticks,
           color: "#84888C",  
            font: {
              family: "OpenSans",
              size: 12,
            }
          },
          title:{
            ...commonOptions.scales.x.title,
            display: noSubscription ? false: true,
            color: "#84888C",  
            font: {
              family: "OpenSans",
              size: 12,
            }
          }
        },
        y:{
          ...commonOptions.scales.y,
          ticks:{
            display: noSubscription ? false: true,
           ...commonOptions.scales.y.ticks,
           color: "#84888C",  
           font: {
             family: "OpenSans",
             size: 12,
           }
          },
          title:{
            ...commonOptions.scales.y.title,
            display: noSubscription ? false: true,
            color: "#84888C",  
            font: {
              family: "OpenSans",
              size: 12,
            }
          }
        }
      }
      // maintainAspectRatio:false
    };

    return (
      <>
        {noSubscription ? <NoSubscription isNoHidsSelected={noSubscription == 2} subscription={metric?.moduleNames} /> : <></> }
        <Bar data={data} options={barOptions} />
        {noSubscription ? <></> : <CustomLegends datasets={datasets} /> }
      </>
    );
  };

  let FromDate, ToDate;
  if (showTimePeriod) {
    ({ FromDate, ToDate } = DateRange || {});
  }

  const PeriodType =
  periodValue == 5 ? "YTD" : periodValue == 4 ? "Trailing 12" : periodValue == 1 ? "Current Period" :null



  return (
    <div
      className={`bar-chart-metric chart-metric ${aspectRatio < 0.4 ? "view-1-3" : ""}`}
      style={{ width: "100%", margin: "0 auto" }}
    >
      <h3 className="chart-heading" style={{ whiteSpace: "pre-wrap" }}>
        <div className="d-flex">
          <EllipsisWithTooltip placement="top">{chartTitle}</EllipsisWithTooltip>
          {showTimePeriod && <span className="badge">{`Showing ${PeriodType} ${FromDate} - ${ToDate}`}
            <span>
            <OverlayTrigger
                placement="top"
                delay={{ show: 100, hide: 200 }}
                overlay={
                  <ReactBootstrapTooltip id={"chartInfo"}>
                    This Data can only be shown on a month by month basis
                  </ReactBootstrapTooltip>
                }>
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" version="1.1" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"></path><path d="M10 12h-4v-1h1v-3h-1v-1h3v4h1z"></path><path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"></path></svg>
                  </OverlayTrigger>
            </span>  
          </span>}
        </div>
      </h3>
      {renderBarChart()}
    </div>
  );
};

export default React.memo(BarChartCard);
